import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BootstrapDialog } from '../../../../assets/style/globalStyle';
import { isMobile } from 'react-device-detect';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import { selectLogin } from '../../../../store/login/loginSlice';
import { startAndStop } from '../../../../store/loading/loadingSlice';
import axios from 'axios';

import {
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import Iconify from '../../../../@core/theme/Iconify';
import configAxios from 'src/services/configAxios';

const schedulingClients = (props) => {
  const dispatch = useDispatch();
  const [infosClients] = useState(props.otherInfos);
  const [infosScheduling, setInfosScheduling] = useState({});
  const [titlebutton, setInfosTitleButton] = useState(
    infosClients.id_schedules ? 'Reagendar' : 'Agendar'
  );

  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });

  useEffect(() => {
    if (infosClients.id_schedules) {
      setInfosScheduling({
        id: infosClients.id_schedules,
        dtentrevis: infosClients.dtentrevis,
        horaentrevis: infosClients.horaentrevis,
        link_reuniao: infosClients.link_reuniao,
        codigo_evento: infosClients.codigo_evento,
        uuid_cal: infosClients.uuid_cal
      });
    }
  }, []);

  async function HandleSubmit(event) {
    event.preventDefault();

    const infosSchedulingSubmit = {
      ...infosScheduling,
      id_client: infosClients.id
    };

    if (infoState.integracal === 'Sim') {
      const urlIntegration = infoState.rotapostback;
      let calInfos;
      let router = infosClients.id_schedules ? '/cal/rescheduleBooking' : '/cal/generateBookings';

      dispatch(startAndStop(true));

      if (infosClients.id_schedules) {
        calInfos = {
          bookingId: infosClients.uuid_cal ? infosClients.uuid_cal : infosScheduling.uuid_cal,
          start: `${infosScheduling.dtentrevis}T${infosScheduling.horaentrevis}-03:00`
        };
      } else {
        calInfos = {
          start: `${infosScheduling.dtentrevis}T${infosScheduling.horaentrevis}-03:00`,
          eventTypeId: infosScheduling.codigo_evento,
          attendee: {
            language: 'pt',
            name: infosClients.nome,
            timeZone: 'America/Sao_Paulo',
            email: infosClients.email
          }
        };
      }

      try {
        const resCal = await axios.post(`${urlIntegration}${router}`, calInfos, {
          headers: {
            authorization: `Bearer ${infoState.tokenpostback}`
          }
        });

        if (resCal.data.status === 'success') {
          infosSchedulingSubmit.uuid_cal = resCal.data.data.uid;
          infosSchedulingSubmit.link_reuniao = resCal.data.data.meetingUrl;

          const result = await configAxios.post('/scheduling/addScheduling', infosSchedulingSubmit);

          if (result.status === 200) {
            NotificationManager.success(
              infosClients.id_schedules
                ? 'Reagendamento realizado com sucesso!'
                : 'Agendamento realizado com sucesso!',
              'Sucesso'
            );

            setInfosScheduling({
              ...infosScheduling,
              uuid_cal: resCal.data.data.uid ? resCal.data.data.uid : infosClients.uuid_cal,
              link_reuniao: resCal.data.data.meetingUrl
                ? resCal.data.data.meetingUrl
                : infosClients.link_reuniao,
              id: result.data.id
            });

            infosClients.id_schedules = result.data.id;
            infosClients.uuid_cal = result.data.bookingId;
            props.setOpenModal(false);
            setInfosTitleButton('Reagendar');
          } else {
            const infosCancelCal = {
              bookingId: resCal.data.uuid
            };
            await axios.post(`${urlIntegration}/cal/cancelBookings`, infosCancelCal, {
              headers: {
                authorization: `Bearer ${infoState.tokenpostback}`
              }
            });
            infosSchedulingSubmit.uuid_cal = '';
            infosSchedulingSubmit.link_reuniao = '';

            NotificationManager.warning(
              'Data e horário já estão sendo utilizados, por favor, escolha outra data e/ou horário!',
              'Atenção'
            );
          }
        } else {
          NotificationManager.error(
            'Tivemos dificuldades para atender a requisição no momento, por favor, tente novamente!',
            'Atenção'
          );
        }
        dispatch(startAndStop(false));
      } catch {
        dispatch(startAndStop(false));
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, por favor, tente novamente!',
          'Atenção'
        );
      }
    } else {
      try {
        const result = await configAxios.post('/scheduling/addScheduling', infosSchedulingSubmit);
        if (result.status === 200) {
          NotificationManager.success(
            infosClients.id_schedules
              ? 'Reagendamento realizado com sucesso!'
              : 'Agendamento realizado com sucesso!',
            'Sucesso'
          );

          setInfosScheduling({
            ...infosScheduling,
            id: result.data.id
          });

          infosClients.id_schedules = result.data.id;
          props.setOpenModal(false);
          setInfosTitleButton('Reagendar');
        } else {
          NotificationManager.warning(
            'Data e horário já estão sendo utilizados, por favor, escolha outra data e/ou horário!',
            'Atenção'
          );
        }
      } catch (error) {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, por favor, tente novamente!',
          'Atenção'
        );
      }
    }
  }
  async function HandleCancelEvent() {
    if (infoState.integracal === 'Sim') {
      const urlIntegration = infoState.rotapostback;
      const infosCancelCal = {
        bookingId: infosClients.uuid_cal ? infosClients.uuid_cal : infosScheduling.uuid_cal
      };
      dispatch(startAndStop(true));

      try {
        await axios.post(`${urlIntegration}/cal/cancelBooking`, infosCancelCal, {
          headers: {
            authorization: `Bearer ${infoState.tokenpostback}`
          }
        });
        await configAxios.post('/scheduling/deleteScheduling', {
          id: infosClients.id_schedules
        });

        NotificationManager.success('Cancelamento realizado com sucesso!', 'Sucesso');
        setInfosScheduling({});
        infosClients.id_schedules = null;
        setInfosTitleButton('Agendar');
        props.setOpenModal(false);
        dispatch(startAndStop(false));
      } catch (error) {
        // console.log(error);
        dispatch(startAndStop(false));
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, por favor, tente novamente!',
          'Atenção'
        );
      }
    } else {
      try {
        await configAxios.post('/scheduling/deleteScheduling', {
          id: infosClients.id_schedules
        });
        NotificationManager.success('Cancelamento realizado com sucesso!', 'Sucesso');
        setInfosScheduling({});
        infosClients.id_schedules = null;
        setInfosTitleButton('Agendar');
        props.setOpenModal(false);
        dispatch(startAndStop(false));
      } catch (error) {
        // console.log(error);
        dispatch(startAndStop(false));
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, por favor, tente novamente!',
          'Atenção'
        );
      }
    }
  }

  function HandleInputChange(event) {
    setInfosScheduling({ ...infosScheduling, [event.target.name]: event.target.value });
  }

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 10,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
  };

  return (
    <>
      <div>
        <BootstrapDialog
          onClose={() => {
            props.setOpenModal(false);
          }}
          aria-labelledby="customized-dialog-title"
          fullWidth
          maxWidth={'sm'}
          open={props.openModal}>
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={() => {
              props.setOpenModal(false);
            }}>
            Agendar entrevista qualificada
          </BootstrapDialogTitle>
          <form onSubmit={HandleSubmit}>
            <DialogContent dividers>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} sx={isMobile ? {} : { mt: 2 }}>
                  <TextField
                    name="dtentrevis"
                    label="Data da entrevista"
                    fullWidth
                    type="date"
                    required
                    variant="outlined"
                    size="small"
                    value={infosScheduling.dtentrevis || ''}
                    onChange={(event) => HandleInputChange(event)}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} sx={isMobile ? {} : { mt: 2 }}>
                  <TextField
                    name="horaentrevis"
                    label="Hora da entrevista"
                    fullWidth
                    type="time"
                    required
                    variant="outlined"
                    size="small"
                    value={infosScheduling.horaentrevis || ''}
                    onChange={(event) => HandleInputChange(event)}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
              </Grid>
              {infoState.integracal === 'Sim' && (
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} sx={isMobile ? {} : { mt: 1 }}>
                    <InputLabel id="label" sx={{ fontSize: '13px' }}>
                      Tempo de entrevista *
                    </InputLabel>
                    <Select
                      name="codigo_evento"
                      fullWidth
                      size="small"
                      required
                      value={infosScheduling.codigo_evento || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      <MenuItem value={infoState.codigo15minutos}>15 minutos</MenuItem>
                      <MenuItem value={infoState.codigo30minutos}>30 minutos</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={6} sx={isMobile ? {} : { mt: 3.2 }}>
                    <TextField
                      name="link_reuniao"
                      label="Link da entrevista"
                      fullWidth
                      variant="outlined"
                      size="small"
                      disabled
                      value={infosScheduling.link_reuniao || ''}
                      onChange={(event) => HandleInputChange(event)}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </Grid>
                </Grid>
              )}
            </DialogContent>
            <DialogActions>
              {infosClients.id_schedules && (
                <Button
                  onClick={() => {
                    HandleCancelEvent();
                  }}
                  color="error"
                  variant="outlined"
                  sx={{ textTransform: 'none' }}
                  startIcon={<Iconify icon="eva:calendar-outline" />}>
                  Cancelar
                </Button>
              )}
              <Button
                color="success"
                variant="contained"
                type="submit"
                startIcon={<Iconify icon="eva:save-fill" />}>
                {titlebutton}
              </Button>
              <Button
                onClick={() => {
                  props.setOpenModal(false);
                }}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="eva:close-circle-fill" />}>
                Fechar
              </Button>
            </DialogActions>
          </form>
        </BootstrapDialog>
      </div>
    </>
  );
};

export default schedulingClients;
